import { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauth, object = auth
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;
    // Only call /me on admin routes to avoid noisy 401s on public pages
    const path = typeof window !== "undefined" ? window.location.pathname : "";
    const onAdmin = path.startsWith("/admin");
    const hasToken = typeof localStorage !== "undefined" && !!localStorage.getItem("obfz_token");
    if (!onAdmin && !hasToken) {
      setUser(false);
      return () => {};
    }
    api
      .get("/auth/me")
      .then((r) => mounted && setUser(r.data))
      .catch(() => mounted && setUser(false));
    return () => {
      mounted = false;
    };
  }, []);

  const login = async (username, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { username, password });
      if (data.access_token) localStorage.setItem("obfz_token", data.access_token);
      setUser(data);
      return true;
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
      return false;
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // noop
    }
    localStorage.removeItem("obfz_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, error, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
